import React from 'react';
import PropTypes from 'prop-types';

import '!style-loader!css-loader!./PayWayITunes.css';
import { converter } from '../../../helpers/converter';
import logoITunes from './iTunes.png';

export default function MethodITunes({ translations, visible }) {
  if (!visible) {
    return null;
  }

  return (
    <div className="row pay-way-item i-tunes">
      <div className="col-lg-10 col-md-10 col-sm-10 col-xs-12">
        <div className="row">
          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-3">
            <img src={logoITunes} alt="" />
          </div>
          <div className="col-lg-10 col-md-10 col-sm-10 col-xs-9">
            <b>
              {converter.convertApaUnicode(
                translations,
                'payment_method_registered_itunes',
                'Método de pago iTunes (sólo en dispositivos iOS)',
              )}
            </b>
          </div>
        </div>
      </div>
    </div>
  );
}

MethodITunes.propTypes = {
  translations: PropTypes.shape({}),
  visible: PropTypes.bool,
};

MethodITunes.defaultProps = {
  visible: false,
};
